export default __webpack_public_path__ + "static/media/4-1-asPerMeansOfVerification.6b1101ef.png";